import React, { useState, useEffect } from 'react';
import { Button, Card, Form, Modal, Row, Col } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import Layout from '../../layout/default';
import Block from '../../components/Block/Block';
import DataTable from '../../components/DataTable/DataTable';
import { Icon } from "../../components"
import { userColumns } from "../../store/cities/CitiesData";
import instance from "../api"

function CitiesList() {
    const { city_id } = useParams();

    // NEW CODE
  const [ searchText, setSearchText ] = useState("")
    // NEW CODE ENDS
    
    const [showModal, setShowModal] = useState(false);
    const [citiesData, setCitiesData] = useState([]);
    const [statesData, setStatesData] = useState([]);

    const [stateId, setStateId] = useState('');
    const [cityName, setCityName] = useState('');
    const [cityCode, setCityCode] = useState('');
    const [editingCity, setEditingCity] = useState(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [fieldErrors, setFieldErrors] = useState({
        stateId: false,
        cityName: false,
    });

    const handleShowModal = () => setShowModal(true);
    const navigate = useNavigate();

    const handleCloseModal = () => {
        setShowModal(false);
        resetForm();
        navigate('/cities-manage/cities-list');
    };

    const resetForm = () => {
        setStateId('');
        setCityName('');
        setCityCode('');
        setEditingCity(null);
        setFieldErrors({
            stateId: false,
            cityName: false,
            cityCode: false
        });
    };

    const validateForm = () => {
        const errors = {};

        if (!stateId) errors.stateId = true;
        if (!cityName) errors.cityName = true;

        setFieldErrors(errors);

        return Object.values(errors).every(error => !error);
    };

  
    const fetchStates = async () => {
        try {
            const response = await instance.get(`api/Master/Zone`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json; charset=utf-8',
                   'ngrok-skip-browser-warning':'true',
                }
            });
            setStatesData(response.data.rows);
        } catch (error) {
            console.error('Error fetching states:', error);
        }
    };

    const fetchData =  async (page, pageSize) => {
        try {
            const queryParams = `pageSize=${pageSize}&page=${page}` + 
                      (searchText ? `&search=${searchText}` : '');
  
            const citiesResponse = await instance.get(
                `api/Master/City?${queryParams}`
            );
            setCitiesData(citiesResponse.data.rows);
            setTotalCount(citiesResponse.data.count);

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchCityDetails = async () => {
        try {
            const response = await instance.get(`api/Master/City/${city_id}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json; charset=utf-8',
                   'ngrok-skip-browser-warning':'true',
                }
            });
            const city = response.data;
            setCityName(city.name || '');
            setCityCode(city.code || '');
            setStateId(city.zone_id || '');

            setEditingCity(city);
            handleShowModal();
        } catch (error) {
            console.error('Error fetching City details:', error);
        }
    };

    const postData = async () => {
        if (!validateForm()) return;

        try {
            const payload = {
                zone_id: stateId,
                name: cityName,
                code: cityCode
            };

            let response;
            if (editingCity) {
                response = await instance.put(`api/Master/City/update/${editingCity.city_id}`, payload);
            } else {
                response = await instance.post('api/Master/City/create', payload);
            }

            // console.log('City response:', response.data);
            handleCloseModal();
            fetchData();
            Swal.fire('Success', 'City updated successfully!', 'success');
        } catch (error) {
            console.error('Error:', error);
            Swal.fire('Error', 'Failed to update City!', 'error');
        }
    };

    useEffect(() => {
        fetchData(page, rowsPerPage);
        if (city_id) {
            fetchCityDetails();
        }
    }, [ city_id, page, rowsPerPage, searchText ]);
    

  // NEW CODE
    const handleSearchTextChange = (text) => {
    setSearchText(text);
    };
    // NEW CODE ENDS
    

    const handleChangePage = (_event, newPage) => {
        setPage(newPage);
    };
    
    const handleChangeRowsPerPage = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setRowsPerPage(newSize);
        setPage(0);
    };
    useEffect(() => {
        fetchStates();
    }, []);

    const handleStateChange = (e) => {
        const selectedStateId = e.target.value;
        setStateId(selectedStateId);
    };

    const cityColumns = userColumns({ setCitiesData });

    return (
        <Layout title="Cities List" content="container">
            <Block.Head>
                <Block.HeadBetween>
                    <Block.HeadContent>
                        <Block.Title tag="h2">Cities List</Block.Title>
                        {/* <nav>
                            <ol className="breadcrumb breadcrumb-arrow mb-0">
                                <li className="breadcrumb-item"><Link to="/home-ecommerce">Home</Link></li>
                                <li className="breadcrumb-item"><Link to="">Cities Manage</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Cities</li>
                            </ol>
                        </nav> */}
                    </Block.HeadContent>
                    <Block.HeadContent>
                        <ul className="d-flex">
                            <li>
                                <Button className="d-none d-md-inline-flex" variant="primary" onClick={handleShowModal}>
                                    <Icon name="plus" />
                                    <span>Add City</span>
                                </Button>
                            </li>
                        </ul>
                    </Block.HeadContent>
                </Block.HeadBetween>
            </Block.Head>

            <Block>
                <Card>
                    <DataTable
                        tableClassName="data-table-head-light table-responsive"
                        data={citiesData}
                        columns={cityColumns}
                        searchList={['name','WebtagZone.name']}
                        // searchTerm="City Name,State"
                        searchTerm="City Name"
                        totalCount={totalCount}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                        // NEW ONE 
            onSearchTextChange={handleSearchTextChange}
            // NEW ONE ENDS
                    />
                    
                </Card>
            </Block>

            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{editingCity ? 'Edit City' : 'Add City'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>
                            <Col>
                                <Form.Group controlId="formCountry">
                                    <Form.Label>Select State</Form.Label>
                                    <Form.Control as="select" onChange={handleStateChange} value={stateId} className={fieldErrors.countryId ? 'is-invalid' : ''}>
                                        <option value="">Select</option>
                                        {statesData.map(state => (
                                            <option key={state.zone_id} value={state.zone_id}>{state.name}</option>
                                        ))}
                                    </Form.Control>
                                    {fieldErrors.zone_id && <div className="invalid-feedback">Please select a state.</div>}
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="formCityName">
                                    <Form.Label>City Name</Form.Label>
                                    <Form.Control type="text" placeholder="Enter city name" value={cityName} onChange={(e) => setCityName(e.target.value)} className={fieldErrors.cityName ? 'is-invalid' : ''}/>
                                    {fieldErrors.cityName && <div className="invalid-feedback">Please enter a city name.</div>}
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group controlId="formCityCode">
                                    <Form.Label>City Code</Form.Label>
                                    <Form.Control type="text" placeholder="Enter city code" value={cityCode} onChange={(e) => setCityCode(e.target.value)} className={fieldErrors.cityCode ? 'is-invalid' : ''}/>
                                    {/* {fieldErrors.cityCode && <div className="invalid-feedback">Please enter a city code.</div>} */}
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
                    <Button variant="primary" onClick={postData}>{editingCity ? 'Update City' : 'Add City'}</Button>
                </Modal.Footer>
            </Modal>
        </Layout>
    );
}

export const handleDeleteCity = async (city_id, setCitiesData) => {
    const confirmed = window.confirm('Are you sure you want to delete this City?');
    if (confirmed) {
        try {
            await instance.delete(`api/Master/City/delete/${city_id}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json; charset=utf-8',
                   'ngrok-skip-browser-warning':'true',
                }
            });
            // console.log(`City with ID ${city_id} deleted successfully.`);
            Swal.fire("Success", "City deleted successfully!", "success");

            const updatedResponse = await instance.get('api/Master/City?pageSize=100000', {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json; charset=utf-8',
                   'ngrok-skip-browser-warning':'true',
                }
            });
            setCitiesData(updatedResponse.data.rows);
        } catch (error) {
            console.error(`Error deleting city with ID ${city_id}:`, error);
            Swal.fire("Error", "Failed to delete City!","error");

            console.error(error.response);
            console.error(error.message);
        }
    }
};

export default CitiesList;
